import { PaymentStatusEnum, PrescriptionStateEnum, Treatment, TreatmentStatusEnum } from '@api/GoodocAPI';

export const getPrescriptionState = (treatment: Treatment) => {
  if (!treatment) {
    return undefined;
  }

  const { status, paymentStatus, prescriptionState } = treatment;

  if (status === 'completion') {
    return 'notYet' as PrescriptionState;
  }

  if (prescriptionState === PrescriptionStateEnum.None) {
    return 'notYet' as PrescriptionState;
  }

  if (
    status === 'orderprescription' &&
    (paymentStatus === PaymentStatusEnum.PaymentCompleted ||
      paymentStatus === PaymentStatusEnum.RefundFailed)
  ) {
    return (
      treatment.prescription?.fileUrls ? 'hasPrescription' : 'nonePrescription'
    ) as PrescriptionState;
  }

  if (
    status === 'orderprescription' &&
    paymentStatus === PaymentStatusEnum.RefundCompleted
  ) {
    return 'notEstimatePayment' as PrescriptionState;
  }

  return 'needPayment' as PrescriptionState;
};

export const getTreatmentPrice = (treatment: Treatment) => {
  return typeof treatment?.fee === 'number'
    ? String(treatment.fee).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : '';
};

export const getUnpaidTreatment = (treatments: Treatment[]) => {
  return treatments?.find(
    (treatment) =>
      treatment.status === TreatmentStatusEnum.Orderprescription &&
      (treatment.paymentStatus === PaymentStatusEnum.Requested ||
        treatment.paymentStatus === PaymentStatusEnum.PaymentFailed ||
        treatment.paymentStatus === PaymentStatusEnum.ConfirmationRequested)
  );
};

export const getRequestTreatment = (treatments: Treatment[]) => {
  return treatments?.find(
    (treatment) => treatment.status === TreatmentStatusEnum.Request
  );
};

export type PrescriptionState =
  | 'notYet'
  | 'needPayment'
  | 'notEstimatePayment'
  | 'nonePrescription'
  | 'hasPrescription'
  | undefined;
